import type { WorkerSchema } from '../types'

/** UI schema for pending shipping addresses (client-side data, not an API worker). */
export const BillLinReceivableAddressSchema: WorkerSchema = {
  workerId: 'bill-lin-receivable-address',
  workerLabel: 'ที่อยู่ค้าง',
  tabIcon: 'map-pin',
  recordPrefix: 'AD',
  apiEndpoint: '',
  defaultSort: { col: 'created_at', dir: 'desc' },
  searchFields: ['addr_name', 'address_text', 'addr_phone'],

  columns: [
    {
      id: 'addr_name',
      header: 'ลูกค้า/ผู้รับ',
      type: 'text',
      editable: false,
      sortable: true,
      visibility: 'always',
    },
    {
      id: 'addr_phone',
      header: 'โทร',
      type: 'tel',
      editable: false,
      visibility: 'always',
    },
    {
      id: 'address_text',
      header: 'ที่อยู่',
      type: 'text',
      editable: false,
      visibility: 'always',
    },
    {
      id: 'source_channel',
      header: 'ที่มา',
      type: 'text',
      editable: false,
      visibility: 'always',
    },
    {
      id: 'age_label',
      header: 'อายุ',
      type: 'text',
      editable: false,
      visibility: 'always',
      width: 100,
    },
    {
      id: '__status__',
      header: 'สถานะ',
      type: 'status',
      editable: false,
      visibility: 'always',
    },
    // Drawer / detail only — table ends at สถานะ (plan §1.3)
    {
      id: 'created_at',
      header: 'วันเวลาแจ้ง',
      type: 'datetime',
      editable: false,
      sortable: true,
      visibility: 'hidden',
      width: 150,
    },
    {
      id: 'expires_at',
      header: 'หมดอายุใน',
      type: 'text',
      editable: false,
      sortable: true,
      visibility: 'hidden',
      width: 168,
    },
  ],

  drawerSections: [
    {
      label: 'CUSTOMER',
      fields: ['addr_name', 'addr_phone', 'phone', 'recipient_phone', 'contact_phone'],
    },
    {
      label: 'SHIPPING',
      fields: ['address_text', 'address', 'province', 'postcode', 'tracking_no'],
    },
    {
      label: 'DETAILS',
      fields: ['source_channel', 'age_label', 'created_at', 'expires_at', 'queue_left_at', 'queue_left_reason', 'updated_at', 'recorded_at', 'record_date', 'remark'],
    },
  ],

  filterOptions: {
    status: ['ค้าง', 'รอตรวจ', 'รายการที่ลบ', 'หมดอายุ'],
    datePresets: [
      'วันนี้',
      '7 วันที่ผ่านมา',
      'เดือนนี้',
      'เดือนที่แล้ว',
      'กำหนดเอง',
    ],
  },

  emptyState: {
    icon: '📍',
    title: 'ไม่มีที่อยู่ค้าง',
    body: 'เปิดแชตบิลลินในไลน์เพื่อจัดการที่อยู่ที่รอส่งของได้เลยครับ',
  },
}
